"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/ReplyPreviewStrip.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _fetcher = require('web/services/fetcher'); var _fetcher2 = _interopRequireDefault(_fetcher);






const ReplyPreviewStrip = ({ preview, variant }) => {
  const refreshPair = preview.thumbnailURL && preview.fileKey
    ? `${preview.fileKey}\0${preview.thumbnailURL}`
    : undefined
  const attemptedPair = _react.useRef(undefined)
  const [refreshedThumbnail, setRefreshedThumbnail] = _react.useState


()
  const thumbnailURL = refreshedThumbnail && refreshedThumbnail.pair === refreshPair
    ? refreshedThumbnail.url
    : preview.thumbnailURL

  _react.useEffect.call(void 0, () => {
    attemptedPair.current = undefined
  }, [refreshPair])

  const handleThumbnailError = _react.useCallback.call(void 0, () => {
    if (!refreshPair || !preview.fileKey || attemptedPair.current === refreshPair) return
    attemptedPair.current = refreshPair

    _fetcher2.default.call(void 0, '/get_file_link?key=' + preview.fileKey, 'GET', null)
      .then((response) => {
        const freshURL = _optionalChain([response, 'optionalAccess', _ => _.ThumbnailLink])
        if (typeof freshURL === 'string' && freshURL.trim()) {
          setRefreshedThumbnail({ pair: refreshPair, url: freshURL })
        }
      })
      .catch(() => null)
  }, [preview.fileKey, refreshPair])

  return (
    _react2.default.createElement('span', { className: `reply-preview-strip reply-preview-strip--${variant}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
      ,  thumbnailURL && (
        _react2.default.createElement('img', {
          alt: "",
          'aria-hidden': "true",
          className: "reply-preview-strip--thumbnail",
          onError: handleThumbnailError,
          src: thumbnailURL, __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
        )
      )
      , _react2.default.createElement('span', { className: "reply-preview-strip--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
        ,  variant === 'composer' ? (
          _react2.default.createElement('span', { className: "reply-preview-strip--line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}, "Replying to "
              , _react2.default.createElement('strong', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}, preview.displayName), ": " , preview.content
          )
        ) : (
          _react2.default.createElement(_react2.default.Fragment, null
            ,  !preview.recalled && preview.displayName !== 'Unknown sender' && (
              _react2.default.createElement('span', { className: "reply-quote--sender", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}, preview.displayName)
            )
            , _react2.default.createElement('span', { className: preview.recalled ? 'reply-quote--recalled' : 'reply-quote--content', __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
              , preview.content
            )
          )
        )
      )
    )
  )
}

exports. default = ReplyPreviewStrip
